import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=690fccfe"
import script from "./CompanyItem.vue?vue&type=script&lang=js"
export * from "./CompanyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports